import React, { ComponentType, LazyExoticComponent } from "react";

export enum AemComponent {
    BRICK_CALCULATOR = "BRICK_CALCULATOR",
    CEMENTPLATE_CALCULATOR = "CEMENTPLATE_CALCULATOR",
    CEMENTSCREED_CALCULATOR = "CEMENTSCREED_CALCULATOR",
    EPDM_CALCULATOR = "EPDM_CALCULATOR",
    CORRUGATED_SHEET_CALCULATOR = "CORRUGATED_SHEET_CALCULATOR",
    GLASS_BRICK_CALCULATOR = "GLASS_BRICK_CALCULATOR",
    ROOFING_CALCULATOR = "ROOFING_CALCULATOR",
    STABILIZEDSAND_CALCULATOR = "STABILIZEDSAND_CALCULATOR",
    TILE_CALCULATOR = "TILE_CALCULATOR",
    WALLPAPER_CALCULATOR = "WALLPAPER_CALCULATOR",
    YTONG_CALCULATOR = "YTONG_CALCULATOR",
    GRAVEL_CALCULATOR = "GRAVEL_CALCULATOR",
    INACTIVITY_MONITOR = "INACTIVITY_MONITOR",
    PRODUCT_FACING = "PRODUCT_FACING",
    SAFETY_INFO = "SAFETY_INFO",
    FAQ = "FAQ",
    AIDEN_I_FRAME = "AIDEN_I_FRAME",
    SIDEBAR = "SIDEBAR",
    ACCOUNT_BUTTON = "ACCOUNT_BUTTON",
    ORDER_OVERVIEW = "ORDER_OVERVIEW",
    HEADER_BUTTON = "HEADER_BUTTON",
    PROFILE_DETAILS = "PROFILE_DETAILS",
    PROFILE_CREDENTIALS = "PROFILE_CREDENTIALS",
    PROFILE_PREFERENCES = "PROFILE_PREFERENCES",
    PROFILE_ADDRESSES = "PROFILE_ADDRESSES",
    BONUS_CARD_BALANCE = "BONUS_CARD_BALANCE",
    REQUEST_BONUS_CARD = "REQUEST_BONUS_CARD",
    DISCOUNT = "DISCOUNT",
    ORDER_DETAIL = "ORDER_DETAIL",
    ORDER_LIST = "ORDER_LIST",
    PHONE_NUMBER = "PHONE_NUMBER",
    TOOLTIP = "TOOLTIP",
    TEXT = "TEXT",
    SHOPPING_CART = "SHOPPING_CART",
    LOGOUT_BUTTON = "LOGOUT_BUTTON",
    TRANSPORT_SERVICE = "TRANSPORT_SERVICE",
    CONFIRM_GUEST = "CONFIRM_GUEST",
    FLYOUT_MENU = "FLYOUT_MENU",
    HAMBURGER = "HAMBURGER",
    RESET_PASSWORD_FORM = "RESET_PASSWORD_FORM",
    CART_BUTTON = "CART_BUTTON",
    SHOPPING_CART_OVERVIEW = "SHOPPING_CART_OVERVIEW",
    CTA_WRAPPER = "CTA_WRAPPER",
    BOX_COUNTER = "BOX_COUNTER",
    CHECKOUT_DETAILS_BUTTON = "CHECKOUT_DETAILS_BUTTON",
    CHECKOUT_BUTTON = "CHECKOUT_BUTTON",
    ERROR_MESSAGES = "ERROR_MESSAGES",
    CONTENT_LIST_BLOCK = "CONTENT_LIST_BLOCK",
    PREFERRED_STORE_BUTTON = "PREFERRED_STORE_BUTTON",
    SMALL_HEADER_BACK_BUTTON = "SMALL_HEADER_BACK_BUTTON",
    PROFILE_SIDEBAR = "PROFILE_SIDEBAR",
    PROFILE_MENU_BUTTON = "PROFILE_MENU_BUTTON",
    PROFILE_ADDRESS_BOOK = "PROFILE_ADDRESS_BOOK",
    PRODUCT_TILE = "PRODUCT_TILE",
    ADD_BONUS_CARD = "ADD_BONUS_CARD",
    MESSAGES = "MESSAGES",
    LOGOUT_LINK = "LOGOUT_LINK",
    CHECKOUT_CUSTOMER = "CHECKOUT_CUSTOMER",
    CHECKOUT_PAYMENT_METHODS = "CHECKOUT_PAYMENT_METHODS",
    CART_CHECK = "CART_CHECK",
    VACANCY_GROUP = "VACANCY_GROUP",
    CONFIGURABLE_PRODUCT = "CONFIGURABLE_PRODUCT",
    AUTHORISATION_PROVIDER = "AUTHORISATION_PROVIDER",
    ADD_TO_WISHLIST_MODAL = "ADD_TO_WISHLIST_MODAL",
    WISHLIST_SIDEBAR = "WISHLIST_SIDEBAR",
    WISHLIST_DETAIL = "WISHLIST_DETAIL",
    WISHLIST_SHAREABLE_DETAIL = "WISHLIST_SHAREABLE_DETAIL",
    WISHLIST_MENU_BUTTON = "WISHLIST_MENU_BUTTON",
    WISHLIST_INFOBLOCK = "WISHLIST_INFOBLOCK",
    PARCEL_PERFORM = "PARCEL_PERFORM",
    REQUEST_BONUS_CARD_BLOCK = "REQUEST_BONUS_CARD_BLOCK",
    BACK_TO_TOP = "BACK_TO_TOP",
    BLOCK_SECTION = "BLOCK_SECTION",
    IFRAME = "IFRAME",
    FEATURE_SWITCH = "FEATURE_SWITCH",
    CASHBACK_MODAL = "CASHBACK_MODAL",
    RICH_TEXT_MODAL = "RICH_TEXT_MODAL",
    NEWSLETTER_UNSUBSCRIBE_MODAL = "NEWSLETTER_UNSUBSCRIBE_MODAL"
}

const CtaWrapper = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/CallToActions/CtaWrapper/ctaWrapper.container"
    ).then((module) => ({
        default: module.CtaWrapper
    }))
);

const ErrorMessages = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/ErrorMessages/errorMessages.container"
    ).then((module) => ({
        default: module.ErrorMessages
    }))
);

const FlyoutMenu = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@/components/Navigation/FlyoutMenu/flyoutMenu.container"
    ).then((module) => ({
        default: module.FlyoutMenu
    }))
);

const ProductTileAdapter = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Product/ProductTile/productTile.adapter"
    ).then((module) => ({
        default: module.ProductTileAdapter
    }))
);

const GlassBrickCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Calculator/GlassBrickCalculator/glassBrickCalculator.container"
    ).then((module) => ({
        default: module.GlassBrickCalculator
    }))
);

const Hamburger = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/General/Hamburger/hamburger.container"
    ).then((module) => ({
        default: module.Hamburger
    }))
);

const HeaderButton = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@/components/Navigation/Buttons/HeaderButton/headerButton.container"
    ).then((module) => ({
        default: module.HeaderButton
    }))
);

const LogoutButtonContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Account/LogoutButton/logoutButton.container"
    ).then((module) => ({
        default: module.LogoutButtonContainer
    }))
);

const LogoutLinkContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Account/LogoutLink/logoutLink.container"
    ).then((module) => ({
        default: module.LogoutLinkContainer
    }))
);

const MessagesContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/General/Messages/messages.container"
    ).then((module) => ({
        default: module.Messages
    }))
);

const NewsletterUnsubscribeModal = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Modals/NewsletterUnsubscribeModal/newsletterUnsubscribeModal"
    ).then((module) => ({
        default: module.NewsletterUnsubscribeModal
    }))
);

const AidenIFrameComponent = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/AidenIFrame/AidenIFrame.container"
    ).then((module) => ({
        default: module.AidenIFrameContainer
    }))
);

const OrderDetailContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Order/OrderDetail/orderDetail.container"
    ).then((module) => ({
        default: module.OrderDetail
    }))
);

const OrderListContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Account/OrderList/orderList.container"
    ).then((module) => ({
        default: module.OrderListContainer
    }))
);

const OrderOverviewContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Order/OrderOverview/orderOverview.container"
    ).then((module) => ({
        default: module.OrderOverview
    }))
);

const PhoneNumberContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/General/PhoneNumber/phoneNumber.container"
    ).then((module) => ({
        default: module.PhoneNumberContainer
    }))
);

const PreferredStoreButton = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/PreferredStoreButton/preferredStoreButton.container"
    ).then((module) => ({
        default: module.PreferredStoreButton
    }))
);

const ProductFacingContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Product/ProductFacing/productFacing.container"
    ).then((module) => ({
        default: module.ProductFacingContainer
    }))
);

const DiscountContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Discount/discount.container"
    ).then((module) => ({
        default: module.DiscountContainer
    }))
);

const ProfileAddressBook = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Account/Profile/ProfileAddressBook/profileAddressBook.container"
    ).then((module) => ({
        default: module.ProfileAddressBook
    }))
);

const ProfileAddressesContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Profile/Addresses/adresses.container"
    ).then((module) => ({
        default: module.ProfileAddressesContainer
    }))
);

const ProfileCredentialsContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Profile/Credentials/credentials.container"
    ).then((module) => ({
        default: module.ProfileCredentialsContainer
    }))
);

const ProfileDetailsContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Profile/Details/details.container"
    ).then((module) => ({
        default: module.ProfileDetailsContainer
    }))
);

const ProfileMenuButtonContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Account/Profile/ProfileMenuButton/profileMenuButton.container"
    ).then((module) => ({
        default: module.ProfileMenuButtonContainer
    }))
);

const ProfilePreferencesContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Profile/Preferences/preferences.container"
    ).then((module) => ({
        default: module.ProfilePreferencesContainer
    }))
);

const ProfileSidebarContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Account/Profile/ProfileSidebar/profileSidebar.container"
    ).then((module) => ({
        default: module.ProfileSidebarContainer
    }))
);

const RequestBonusCard = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Account/RequestBonusCard/requestBonusCard.container"
    ).then((module) => ({
        default: module.RequestBonusCard
    }))
);

const ResetPasswordFormContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Account/ResetPasswordForm/resetPasswordForm.container"
    ).then((module) => ({
        default: module.ResetPasswordFormContainer
    }))
);

const RoofingCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Calculator/RoofingCalculator/roofingCalculator.container"
    ).then((module) => ({
        default: module.RoofingCalculator
    }))
);

const SafetyInfoContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Product/SafetyInfo/safetyInfo.container"
    ).then((module) => ({
        default: module.SafetyInfoContainer
    }))
);

const ShoppingCartContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Cart/ShoppingCart/shoppingCart.container"
    ).then((module) => ({
        default: module.ShoppingCartContainer
    }))
);

const ShoppingCartOverviewContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Cart/ShoppingCartOverview/shoppingCartOverview.container"
    ).then((module) => ({
        default: module.ShoppingCartOverviewContainer
    }))
);

const Sidebar = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@/components/Navigation/Sidebar/sidebar.container"
    ).then((module) => ({
        default: module.Sidebar
    }))
);

const SmallHeaderBackButton = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/SmallHeaderBackButton/smallHeaderBackButton.container"
    ).then((module) => ({
        default: module.SmallHeaderBackButton
    }))
);

const StabilizedsandCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Calculator/StabilizedSandCalculator/stabilizedSandCalculator.container"
    ).then((module) => ({
        default: module.StabilizedsandCalculator
    }))
);

const TextContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/General/Text/text.container"
    ).then((module) => ({
        default: module.TextContainer
    }))
);

const TileCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Calculator/TileCalculator/tileCalculator.container"
    ).then((module) => ({
        default: module.TileCalculator
    }))
);

const TooltipContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/General/Tooltip/tooltip.container"
    ).then((module) => ({
        default: module.TooltipContainer
    }))
);

const WallpaperCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Calculator/WallpaperCalculator/wallpaperCalculator.container"
    ).then((module) => ({
        default: module.WallpaperCalculator
    }))
);

const YtongCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Calculator/YtongCalculator/ytongCalculator.container"
    ).then((module) => ({
        default: module.YtongCalculator
    }))
);

const CheckoutPaymentMethodsContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Checkout/Payment/payment.container"
    ).then((module) => ({
        default: module.PaymentContainer
    }))
);

const FaqContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/General/Faq/faq.default"
    ).then((module) => ({
        default: module.FaqDefault
    }))
);

const InactivityMonitorContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Ecorner/InactivityMonitor/inactivityMonitor.container"
    ).then((module) => ({ default: module.InactivityMonitorContainer }))
);

const TransportService = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Checkout/TransportService/transportService"
    ).then((module) => ({ default: module.TransportService }))
);

const VacancyGroup = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/VacancyGroup/vacancyGroup.container"
    ).then((module) => ({
        default: module.VacancyGroup
    }))
);

const ContentListBlock = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/ContentListBlock/contentListBlock.container"
    ).then((module) => ({ default: module.ContentListBlock }))
);

const CartButtonContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@/components/Navigation/Buttons/CartButton/cartButton.container"
    ).then((module) => ({
        default: module.CartButton
    }))
);

const CartCheckContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Cart/CartCheck/cartCheck.container"
    ).then((module) => ({
        default: module.CartCheckContainer
    }))
);

const CementplateCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Calculator/CementplateCalculator/cementplateCalculator.container"
    ).then((module) => ({ default: module.CementplateCalculator }))
);

const CementscreedCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Calculator/CementscreedCalculator/cementscreedCalculator.container"
    ).then((module) => ({ default: module.CementscreedCalculator }))
);

const CorrugatedSheetCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Calculator/CorrugatedSheetCalculator/corrugatedSheetCalculator.container"
    ).then((module) => ({ default: module.CorrugatedSheetCalculator }))
);

const EPDMCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Calculator/EPDMCalculator/epdmCalculator.container"
    ).then((module) => ({ default: module.EPDMCalculator }))
);

const CheckoutButton = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Checkout/CheckoutButton/checkoutButton.container"
    ).then((module) => ({ default: module.CheckoutButton }))
);

const CheckoutDetailsButton = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Checkout/CheckoutDetailsButton/checkoutDetailsButton.container"
    ).then((module) => ({ default: module.CheckoutDetailsButton }))
);

const ConfirmGuestContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Account/ConfirmGuest/confirmGuest.container"
    ).then((module) => ({ default: module.ConfirmGuestContainer }))
);

const CheckoutCustomerContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Checkout/CheckoutCustomer/checkoutCustomer.container"
    ).then((module) => ({ default: module.CheckoutCustomerContainer }))
);

const BrickCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Calculator/BrickCalculator/brickCalculator.container"
    ).then((module) => ({ default: module.BrickCalculator }))
);

const BoxCounterContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Product/BoxCounter/boxCounter.container"
    ).then((module) => ({ default: module.BoxCounterContainer }))
);

const BonusCardBalanceContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@omni/components/components/Account/BonusCardBalance/bonusCardBalance.container"
    ).then((module) => ({ default: module.BonusCardBalanceContainer }))
);

const AccountButton = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@/components/Navigation/Buttons/AccountButton/accountButton.container"
    ).then((module) => ({ default: module.AccountButton }))
);

const AddBonusCard = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Account/AddBonusCard/addBonusCard.container"
    ).then((module) => ({ default: module.AddBonusCard }))
);

const ConfigurableProductComponent = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Product/ConfigurableProduct/configurableProduct.component"
    ).then((module) => ({
        default: module.ConfigurableProductComponent
    }))
);

const AuthorisationProvider = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/utils/authorisation/authorisation.provider"
    ).then((module) => ({
        default: module.AuthorisationProvider
    }))
);

const AddToWishlistModal = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Wishlist/AddToWishlistModal/AddToWishlist.modal"
    ).then((module) => ({
        default: module.AddToWishlistModal
    }))
);

const WishlistSidebarContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Wishlist/WishlistSidebar/WishlistSidebar.container"
    ).then((module) => ({
        default: module.WishlistSidebarContainer
    }))
);

const WishlistMenuButtonContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Wishlist/WishlistMenuButton/wishlistMenuButton.container"
    ).then((module) => ({
        default: module.WishlistMenuButtonContainer
    }))
);

const WishlistDetailContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Wishlist/WishlistDetail/WishlistDetail.container"
    ).then((module) => ({
        default: module.WishlistDetailContainer
    }))
);

const WishlistShareableDetailContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Wishlist/WishlistDetail/WishlistShareableDetail.container"
    ).then((module) => ({
        default: module.WishlistShareableDetailContainer
    }))
);

const WishlistInfoblockContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Wishlist/WishlistInfoblock/WishlistInfoblock.container"
    ).then((module) => ({
        default: module.WishlistInfoblockContainer
    }))
);

const ParcelPerformContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/ParcelPerform/parcelPerform.container"
    ).then((module) => ({
        default: module.ParcelPerform
    }))
);

const RequestBonusCardBlock = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Order/RequestBonusCardBlock/RequestBonusCard/requestBonusCardBlock.container"
    ).then((module) => ({
        default: module.RequestBonusCardBlock
    }))
);

const BackToTop = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Navigation/BackToTop/backToTop.container"
    ).then((module) => ({
        default: module.BackToTop
    }))
);

const BlockSection = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/General/BlockSection/blockSection.container"
    ).then((module) => ({
        default: module.BlockSection
    }))
);

const Iframe = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/General/Iframe/iframe.container"
    ).then((module) => ({
        default: module.Iframe
    }))
);

const FeatureSwitch = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Utils/featureSwitch/featureSwitch.container"
    ).then((module) => ({
        default: module.FeatureSwitchContainer
    }))
);

const GravelCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Calculator/GravelCalculator/gravelCalculator.container"
    ).then((module) => ({
        default: module.GravelCalculator
    }))
);

const CashbackModal = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Modals/CashbackModal/cashbackModal"
    ).then((module) => ({
        default: module.CashbackModal
    }))
);

const RichTextModal = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@omni/components/components/Modals/RichTextModal/richTextModal"
    ).then((module) => ({
        default: module.RichTextModal
    }))
);

export const AemComponentMap: Record<
    AemComponent,
    LazyExoticComponent<ComponentType<any>>
> = {
    [AemComponent.BRICK_CALCULATOR]: BrickCalculator,
    [AemComponent.CEMENTPLATE_CALCULATOR]: CementplateCalculator,
    [AemComponent.CEMENTSCREED_CALCULATOR]: CementscreedCalculator,
    [AemComponent.EPDM_CALCULATOR]: EPDMCalculator,
    [AemComponent.CORRUGATED_SHEET_CALCULATOR]: CorrugatedSheetCalculator,
    [AemComponent.GLASS_BRICK_CALCULATOR]: GlassBrickCalculator,
    [AemComponent.ROOFING_CALCULATOR]: RoofingCalculator,
    [AemComponent.STABILIZEDSAND_CALCULATOR]: StabilizedsandCalculator,
    [AemComponent.TILE_CALCULATOR]: TileCalculator,
    [AemComponent.WALLPAPER_CALCULATOR]: WallpaperCalculator,
    [AemComponent.YTONG_CALCULATOR]: YtongCalculator,
    [AemComponent.GRAVEL_CALCULATOR]: GravelCalculator,
    [AemComponent.INACTIVITY_MONITOR]: InactivityMonitorContainer,
    [AemComponent.PRODUCT_FACING]: ProductFacingContainer,
    [AemComponent.SAFETY_INFO]: SafetyInfoContainer,
    [AemComponent.FAQ]: FaqContainer,
    [AemComponent.AIDEN_I_FRAME]: AidenIFrameComponent,
    [AemComponent.SIDEBAR]: Sidebar,
    [AemComponent.ACCOUNT_BUTTON]: AccountButton,
    [AemComponent.ORDER_OVERVIEW]: OrderOverviewContainer,
    [AemComponent.HEADER_BUTTON]: HeaderButton,
    [AemComponent.PROFILE_DETAILS]: ProfileDetailsContainer,
    [AemComponent.PROFILE_CREDENTIALS]: ProfileCredentialsContainer,
    [AemComponent.PROFILE_PREFERENCES]: ProfilePreferencesContainer,
    [AemComponent.PROFILE_ADDRESSES]: ProfileAddressesContainer,
    [AemComponent.BONUS_CARD_BALANCE]: BonusCardBalanceContainer,
    [AemComponent.REQUEST_BONUS_CARD]: RequestBonusCard,
    [AemComponent.DISCOUNT]: DiscountContainer,
    [AemComponent.ORDER_DETAIL]: OrderDetailContainer,
    [AemComponent.ORDER_LIST]: OrderListContainer,
    [AemComponent.PHONE_NUMBER]: PhoneNumberContainer,
    [AemComponent.TOOLTIP]: TooltipContainer,
    [AemComponent.TEXT]: TextContainer,
    [AemComponent.SHOPPING_CART]: ShoppingCartContainer,
    [AemComponent.LOGOUT_BUTTON]: LogoutButtonContainer,
    [AemComponent.TRANSPORT_SERVICE]: TransportService,
    [AemComponent.CONFIRM_GUEST]: ConfirmGuestContainer,
    [AemComponent.FLYOUT_MENU]: FlyoutMenu,
    [AemComponent.HAMBURGER]: Hamburger,
    [AemComponent.RESET_PASSWORD_FORM]: ResetPasswordFormContainer,
    [AemComponent.CART_BUTTON]: CartButtonContainer,
    [AemComponent.SHOPPING_CART_OVERVIEW]: ShoppingCartOverviewContainer,
    [AemComponent.CTA_WRAPPER]: CtaWrapper,
    [AemComponent.BOX_COUNTER]: BoxCounterContainer,
    [AemComponent.CHECKOUT_DETAILS_BUTTON]: CheckoutDetailsButton,
    [AemComponent.CHECKOUT_BUTTON]: CheckoutButton,
    [AemComponent.ERROR_MESSAGES]: ErrorMessages,
    [AemComponent.CONTENT_LIST_BLOCK]: ContentListBlock,
    [AemComponent.PREFERRED_STORE_BUTTON]: PreferredStoreButton,
    [AemComponent.SMALL_HEADER_BACK_BUTTON]: SmallHeaderBackButton,
    [AemComponent.PROFILE_SIDEBAR]: ProfileSidebarContainer,
    [AemComponent.PROFILE_MENU_BUTTON]: ProfileMenuButtonContainer,
    [AemComponent.PROFILE_ADDRESS_BOOK]: ProfileAddressBook,
    [AemComponent.PRODUCT_TILE]: ProductTileAdapter,
    [AemComponent.ADD_BONUS_CARD]: AddBonusCard,
    [AemComponent.MESSAGES]: MessagesContainer,
    [AemComponent.LOGOUT_LINK]: LogoutLinkContainer,
    [AemComponent.CHECKOUT_CUSTOMER]: CheckoutCustomerContainer,
    [AemComponent.CHECKOUT_PAYMENT_METHODS]: CheckoutPaymentMethodsContainer,
    [AemComponent.CART_CHECK]: CartCheckContainer,
    [AemComponent.VACANCY_GROUP]: VacancyGroup,
    [AemComponent.CONFIGURABLE_PRODUCT]: ConfigurableProductComponent,
    [AemComponent.AUTHORISATION_PROVIDER]: AuthorisationProvider,
    [AemComponent.ADD_TO_WISHLIST_MODAL]: AddToWishlistModal,
    [AemComponent.WISHLIST_SIDEBAR]: WishlistSidebarContainer,
    [AemComponent.WISHLIST_DETAIL]: WishlistDetailContainer,
    [AemComponent.WISHLIST_SHAREABLE_DETAIL]: WishlistShareableDetailContainer,
    [AemComponent.WISHLIST_MENU_BUTTON]: WishlistMenuButtonContainer,
    [AemComponent.WISHLIST_INFOBLOCK]: WishlistInfoblockContainer,
    [AemComponent.PARCEL_PERFORM]: ParcelPerformContainer,
    [AemComponent.REQUEST_BONUS_CARD_BLOCK]: RequestBonusCardBlock,
    [AemComponent.BACK_TO_TOP]: BackToTop,
    [AemComponent.BLOCK_SECTION]: BlockSection,
    [AemComponent.IFRAME]: Iframe,
    [AemComponent.FEATURE_SWITCH]: FeatureSwitch,
    [AemComponent.CASHBACK_MODAL]: CashbackModal,
    [AemComponent.RICH_TEXT_MODAL]: RichTextModal,
    [AemComponent.NEWSLETTER_UNSUBSCRIBE_MODAL]: NewsletterUnsubscribeModal
};
